import type { ProgressChartsProps } from './types';
import { ChartCarousel } from './ChartCarousel';
import { ProgressChart } from './ProgressChart';
import { ActivityChart } from './ActivityChart';
import { AccuracyTrendChart } from './AccuracyTrendChart';
import { TimeTrendChart } from './TimeTrendChart';
import { AnswerBreakdownChart } from './AnswerBreakdownChart';
import { PassFailChart } from './PassFailChart';

export function ProgressCharts({ sessions, isLoading }: ProgressChartsProps) {
  const charts = [
    { label: 'Progress', component: <ProgressChart sessions={sessions} /> },
    { label: 'Activity', component: <ActivityChart sessions={sessions} /> },
    { label: 'Accuracy', component: <AccuracyTrendChart sessions={sessions} /> },
    { label: 'Time', component: <TimeTrendChart sessions={sessions} /> },
    { label: 'Answers', component: <AnswerBreakdownChart sessions={sessions} /> },
    { label: 'Pass Rate', component: <PassFailChart sessions={sessions} /> },
  ];

  return <ChartCarousel charts={charts} isLoading={isLoading} />;
}
